import React from 'react';
import { useNavigate } from 'react-router-dom';
import Avatar from '../../../submodule/img/01.jpg';

function UserList({ currentItems }) {
  let navigate = useNavigate();

  const handleClick = (userId) => {
    navigate(`/edit/user/${userId}`);
  };

  return (
    <div className="overflow-x-auto">
      <div className="min-w-full inline-block align-middle">
        <div className="overflow-hidden">
          <table className="divide-y divide-gray-200">
            <tbody className="divide-y divide-gray-200 items-center justify-center align-middle">
              {currentItems &&
                currentItems?.map((item) => (
                  <tr
                    key={item.key}
                    onClick={() => {
                      handleClick(item.id);
                    }}
                    className="cursor-pointer">
                    <td className="p-2 whitespace-nowrap">
                      <div className="bg-[#E5E5E5] w-[30px] h-[30px]  flex items-center justify-center rounded-md">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 24 24">
                          <path fill="rgba(0,0,0,0.6)" d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4" />
                        </svg>
                      </div>
                    </td>
                    <td className="p-2 whitespace-nowrap text-sm text-gray-800">{item.full_name}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default UserList;
